<mat-accordion>
    <div class="file-container">
        <!-- IMPORTED FILE DETAILS -->
        <mat-card class="file-details mat-elevation-z3 ">
            <section>
                <h3 class="file-details-header">File Details</h3>
                <ul class="file-details-list">
                    <li>
                         <span class="file-label">Name</span>: {{currentFileName}}
                    </li>
                </ul>
            </section>
              <!-- SPLIT WAYPOINTS IN DIFFERENT FILES -->
            <section class="file-split" *ngIf="selectedFileExportFormat.primaryFormat === '.itn'">
                <h4 class="file-split-header">File Split</h4>
                <div class="file-split-content">
                    <mat-form-field  class="first-control" appearance="fill">
                        <mat-label>Selection</mat-label>
                        <mat-select name="selectWaypoint" [(ngModel)]="selectedSplitWaypoint">
                            <mat-option *ngFor="let item of splitWaypointList" [value]="item">{{item.selection}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="second-control" appearance="fill" >
                        <mat-label>Value</mat-label>
                        <input matInput 
                                type="number" 
                                name="splitWaypointVal" 
                                [(ngModel)]="selectedSplitWaypoint.value"
                                [disabled]="selectedSplitWaypoint.selection !== 'Manual'">
                    </mat-form-field>
                </div>
            </section>

            <!-- FILE EXPORT BUTTON  -->
            <section class="file-export">
                <mat-form-field   appearance="fill">
                    <mat-label>Export File Format</mat-label>
                    <mat-select [(ngModel)]="selectedFileExportFormat" [compareWith]="compareWithFileExtension">
                        <mat-option *ngFor="let file of fileExportFormatList" [value]="file" >{{file.name}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <button mat-raised-button
                        color="warn"
                        class="btn-export"
                        (click)="getExportFileData()"
                        [disabled]="!displayedWaypoints.length">Export</button>
            </section>
        </mat-card>
    </div>
</mat-accordion>